module.exports = __webpack_public_path__ + "static/media/bundle-everyday-digital-web.45ceebb7.png";